export const UPDATE_RETIREMENT_INCOME_GOAL_DATA = 'UPDATE_RETIREMENT_INCOME_GOAL_DATA';
export const MODEL_RETIREMENT_INCOME_GOAL_SCENARIO = 'MODEL_RETIREMENT_INCOME_GOAL_SCENARIO';
export const UPDATE_RETIREMENT_INCOME_GOAL_ERROR = 'UPDATE_RETIREMENT_INCOME_GOAL_ERROR';
export const SET_INITIAL_STATE_FOR_RETIREMENT_INCOME_GOAL = 'SET_INITIAL_STATE_FOR_RETIREMENT_INCOME_GOAL';

export const updateRetirementIncomeGoalData = (data: any) => ({
  type: UPDATE_RETIREMENT_INCOME_GOAL_DATA,
  payload: data,
});

export const modelRetirementIncomeGoalScenario = () => ({
  type: MODEL_RETIREMENT_INCOME_GOAL_SCENARIO,
});

export const updateRetirementIncomeGoalError = (data: any) => ({
  type: UPDATE_RETIREMENT_INCOME_GOAL_ERROR,
  payload: data,
});

export const setInitialStateForRetirementIncomeGoal = (data: any) => ({
  type: SET_INITIAL_STATE_FOR_RETIREMENT_INCOME_GOAL,
  payload: data,
});
